// Migration-ready content: every string and URL below mirrors motivepress.com (OJS). Replace or bind to OJS data when integrating.
export const OJS_BASE = "https://motivepress.com/index.php";

export const site = {
  name: "Motive Press",
  tagline: "Advancing Knowledge Across Disciplines",
  intro:
    "Explore academic research and scholarly publications across science and technology, agriculture and sustainability, and social sciences and humanities.",
  explore:
    "Explore our journals to discover their aims and scope, publishing policies, and submission information.",
  ourJournals: [
    { name: "Motive Journal of Science and Technology", short: "Science & Technology", image: "/media/science.jpg" },
    { name: "Motive Journal of Agriculture and Sustainability", short: "Agriculture & Sustainability", image: "/media/agriculture.jpg" },
    { name: "Motive Journal of Social Sciences and Humanities", short: "Social Sciences & Humanities", image: "/media/humanities.jpg" },
  ],
  languages: [
    { code: "en_US", label: "English", href: `${OJS_BASE}/index/user/setLocale/en_US?source=%2F` },
    { code: "fa_IR", label: "فارسی", href: `${OJS_BASE}/index/user/setLocale/fa_IR?source=%2F` },
  ],
  privacy:
    "The names and email addresses entered in this journal site will be used exclusively for the stated purposes of this journal and will not be made available for any other purpose or to any other party.",
  checklistIntro:
    "As part of the submission process, authors are required to check off their submission's compliance with all of the following items, and submissions may be returned to authors that do not adhere to these guidelines.",
  checklist: [
    "The submission has not been previously published, nor is it before another journal for consideration (or an explanation has been provided in Comments to the Editor).",
    "The submission file is in OpenOffice, Microsoft Word, or RTF document file format.",
    "Where available, URLs for the references have been provided.",
    "The text is single-spaced; uses a 12-point font; employs italics, rather than underlining (except with URL addresses); and all illustrations, figures, and tables are placed within the text at the appropriate points, rather than at the end.",
    "The text adheres to the stylistic and bibliographic requirements outlined in the Author Guidelines.",
  ],
  sections: [{ title: "Articles", policy: "Section default policy" }],
  template: {
    label: "English template",
    image: "/media/word-template.png",
    href: "https://researchsparker.edu.af/public/journals/journal_template.docx",
  },
  indexing: [{ name: "Google Scholar", image: "/media/google-scholar.png", href: "https://scholar.google.com/" }],
  tools: [
    { name: "Grammarly", image: "/media/grammarly.png", href: "https://app.grammarly.com/" },
    { name: "Turnitin", image: "/media/turnitin.jpg", href: "https://www.turnitin.com/" },
    { name: "Zotero", image: "/media/zotero.png", href: "https://www.zotero.org/" },
  ],
  workflow: ["Start", "Upload submission", "Enter metadata", "Confirmation", "Next steps"],
  platform: { label: "Platform and workflow by OJS/PKP", image: "/media/ojs-brand.svg" },
};

export const information = {
  readers: {
    title: "Information For Readers",
    body: "We encourage readers to sign up for the publishing notification service for this journal. Use the Register link at the top of the home page for the journal. This registration will result in the reader receiving the Table of Contents by email for each new issue of the journal. This list also allows the journal to claim a certain level of support or readership. See the journal's Privacy Statement, which assures readers that their name and email address will not be used for other purposes.",
  },
  authors: {
    title: "Information For Authors",
    body: "Interested in submitting to this journal? We recommend that you review the About the Journal page for the journal's section policies, as well as the Author Guidelines. Authors need to register with the journal prior to submitting or, if already registered, can simply log in and begin the five-step process.",
  },
  librarians: {
    title: "Information For Librarians",
    body: "We encourage research librarians to list this journal among their library's electronic journal holdings. As well, it may be worth noting that this journal's open source publishing system is suitable for libraries to host for their faculty members to use with journals they are involved in editing (see Open Journal Systems).",
  },
};

const esgsAbout = [
  "Open Journal Systems is run around the world on everything from shared hosting, to on-premise servers, to VPS and cloud providers. Wherever you deploy, read on to learn about our stable releases and support timelines. As there are many languages in the World, you can choose from a variety of base texts so you cover not only normal letters but also accents, special characters and other alphabets.",
  "As there are many languages in the World, you can choose from a variety of base texts so you cover not only normal letters but also accents, special characters and other alphabets.",
];

const njfsAbout = [
  "As there are many languages in the world, you can choose from a variety of base texts so you cover not only normal letters but also accents, special characters, and other alphabets.",
  "To duplicate a journal in OJS, you can use the Native XML and User XML plugins to export and import the journal's data and user information, respectively. Alternatively, you can duplicate the database and files associated with the journal and then adjust the settings and metadata.",
];

export const journals = [
  {
    slug: "ESGS",
    title: "Earth Systems and Geoscience Studies",
    abbr: "ESGS",
    cover: "/media/geocover.png",
    excerpt: esgsAbout[0].split(". ").slice(0, 1).join(". ") + ".",
    about: esgsAbout,
    welcome: true,
    accent: "#1B3B2B",
  },
  {
    slug: "njfs",
    title: "The new Journal for student",
    abbr: "NJFS",
    cover: "/media/njfs-cover.jpg",
    excerpt: njfsAbout[0],
    about: njfsAbout,
    welcome: false,
    accent: "#9E472A",
  },
];

export const getJournal = (slug) => journals.find((j) => j.slug.toLowerCase() === String(slug).toLowerCase());

export const ojs = (slug, path = "") => `${OJS_BASE}/${slug}${path}`;

export const journalNav = (slug) => [
  { label: "Home", to: `/index.php/${slug}` },
  { label: "Current", to: `/index.php/${slug}/issue/current` },
  { label: "Archives", to: `/index.php/${slug}/issue/archive` },
  { label: "Announcements", to: `/index.php/${slug}/announcement` },
  { label: "About", to: `/index.php/${slug}/about` },
  { label: "Submissions", to: `/index.php/${slug}/about/submissions` },
  { label: "Editorial Team", to: `/index.php/${slug}/about/editorialTeam` },
  { label: "Privacy", to: `/index.php/${slug}/about/privacy` },
  { label: "Contact", to: `/index.php/${slug}/about/contact` },
];
